'use client';

import type { ReactNode } from 'react';
import { LightboxModal } from '@/components/images/lightbox-modal';

export function LightboxProvider({ children }: { children: ReactNode }): React.ReactNode {
  return (
    <>
      {children}
      <LightboxModal />
    </>
  );
}
